module.exports = __webpack_public_path__ + "img/media-en.d983af09.jpg";